export const formatter = (qtdDecimal: number, value: number) => {
  const numberFormatter = new Intl.NumberFormat('pt-BR', {
    minimumIntegerDigits: 1,
    minimumFractionDigits: qtdDecimal,
    maximumFractionDigits: qtdDecimal,
  })

  return numberFormatter.format(value)
}
